import styled from 'styled-components'

export const MapContainer = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  min-height: 320px;

  @media (min-width: 1024px) {
    min-height: 0;
  }
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  color: #808080;
  font-size: 13px;
`
